export function reconcileEvents(previous, incoming, {replaceAll = false, replaceRange = false, start, end} = {}) {
    if (replaceAll) return incoming;
    const ids = new Set(incoming.map(item => String(item.id)));
    const kept = previous.filter(item => {
        if (ids.has(String(item.id))) return false;
        if (!replaceRange) return true;
        const date = String(item.date_event || item.start || '').slice(0, 10);
        return date < start || date > end; // get_events has an inclusive end date
    });
    return [...kept, ...incoming];
}